export const env = {
   api: "https://equipmentbackend.vercel.app",
  };
  
  